import React, { useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { getEventsDetail, getKeywordEvents } from '../../api/home';
import Hr8 from '../../components/hr/Hr8';
import '../../css/Exhibition.css';
import { EventDetailType, KeywordEventType } from '../../@types/home';

export default function EventDetail() {
  const params = useParams();
  const [item, setItem] = useState<EventDetailType>();
  const [eventItem, setEventItem] = useState<KeywordEventType[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    //@ts-ignore
    getEventsDetail(params.eventNo)
      .then((res) => {
        setItem(res.data);
      })
      .catch((err) => console.log(err));
  }, [params]);

  useEffect(() => {
    getKeywordEvents('이벤트', 'ING').then((res: any) => {
      const findIndexById = (id: any) => {
        return res.data.findIndex((item: any) => Number(item.eventNo) === Number(id));
      };
      const idx = findIndexById(params.eventNo);
      if (Number(res.data.length) === 1) {
        setEventItem([]);
      } else {
        if (Number(idx + 1) === Number(res.data.length)) {
          setEventItem([res.data[idx - 1]]);
        } else if (idx !== 0) {
          setEventItem([res.data[idx - 1], res.data[idx + 1]]);
        } else if (idx === 0) {
          setEventItem([res.data[idx + 1]]);
        }
      }
    });
  }, []);
  return (
    <div className="main_wrap">
      <div className="contents_wrap">
        <div className="exhibition_detail_cont">
          <div className="visual_img">
            <img src={`${isMobile ? item?.mobileimageUrl : item?.pcImageUrl}`} alt="" />
          </div>

          {/* 상품 목록 불러와서 사용해야 할 영역 */}

          {isMobile ? <Hr8></Hr8> : null}

          {/* 상품 목록 불러와서 사용해야 할 영역 */}
          <div className="more_exhibition">
            <p>다른 이벤트 보기</p>
            <div className="more_list">
              {eventItem?.map((el: any) => {
                return isMobile ? (
                  <Link to={`/exhibitiondetail/${el?.eventNo}`} key={el?.eventNo}>
                    <img
                      src="../../images/exhibition_more_bg.png"
                      style={{
                        backgroundImage: `url(${isMobile ? el?.mobileimageUrl : el?.pcImageUrl})`,
                      }}
                      alt=""
                    />
                    <div>
                      <p>{el?.label}</p>
                      <span>{`${el?.startYmdt.replaceAll('-', '.').split(' ', 1).join('')} - ${el?.endYmdt
                        .replaceAll('-', '.')
                        .split(' ', 1)
                        .join('')}`}</span>
                    </div>
                  </Link>
                ) : (
                  <>
                    <div>
                      <Link to={`/exhibitiondetail/${el?.eventNo}`} key={el?.eventNo}>
                        <img
                          src="../../images/exhibition_more_bg.png"
                          style={{
                            backgroundImage: `url(${isMobile ? el?.mobileimageUrl : el?.pcImageUrl})`,
                          }}
                          alt=""
                        />
                      </Link>
                      <div>
                        <p>{el?.label}</p>
                        <span>{`${el?.startYmdt.replaceAll('-', '.').split(' ', 1).join('')} - ${el?.endYmdt
                          .replaceAll('-', '.')
                          .split(' ', 1)
                          .join('')}`}</span>
                      </div>
                    </div>
                  </>
                );
              })}
            </div>
            <button
              onClick={() => {
                navigate('/eventlist');
              }}
              className="btn_list"
            >
              목록 보기
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
